import request from './request'

export function fetchArticles (params = {}) {
  return request.get('/articles', { params })
}

export function createArticle (payload) {
  return request.post('/articles', payload)
}

export function updateArticle (id, payload) {
  return request.put(`/articles/${id}`, payload)
}

export function deleteArticle (id) {
  return request.delete(`/articles/${id}`)
}
